<template>
  <div id="nav-bar">
    <table align="center">
      <tr>
        <td>
          <router-link class="nav-link" to="/">Home</router-link>
        </td>
        <td>
          <router-link class="nav-link" to="/leaderboard">Leaderboard</router-link>
        </td>
        <td>
          <router-link class="nav-link" to="/bets">Bets</router-link>
        </td>
        <td>
          <a class="nav-link" @click="navigate('ticket-raffles')">Ticket Raffles</a>
        </td>
        <td style="padding-top:5px; padding-bottom:5px;">
          <a class="gold nav-link" @click="navigate('/gold')" style="font-size:30px;"><b>GOLD</b></a>
        </td>
        <td>
          <a class="nav-link" @click="navigate('/bounties')">Sub Bounties</a>
        </td>
        <td>
          <a class="nav-link" @click="navigate('/rooms')">My Room</a>
        </td>
        <td>
          <a class="nav-link" @click="navigate('/loot-shop')">Loot Shop</a>
        </td>
        <td>
          <a class="nav-link" @click="navigate('/rates')">Rates</a>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  methods: {
    navigate (path) {
      if (this.$route.path === path) {
        this.$router.go(0)
      } else {
        this.$router.push({path})
      }
    }
  }

}
</script>
<style scoped>
#nav-bar {
  width: 100%;
  background-image: linear-gradient(to right, #a82020 , #d82222);
  padding: 5px 0px;
  margin-bottom: 10px;
}
table {
  width: auto;
  border-collapse: collapse;
}
td {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 10px;
  border-left: 1px rgba(0, 0, 0, 0.2) solid;
  border-right: 1px rgba(0, 0, 0, 0.2) solid;
}
.nav-link {
  color: white;
  text-decoration: none;
  font-size: 20px;
  transition: color 0.2s;
  cursor: pointer;
}
.nav-link:hover {
  color: rgba(0, 0, 0, 0.5);
}
.gold:hover {
  /* color: rgba(178, 202, 56, 0.5); */
  color: rgba(0, 0, 0, 0.5);
}
.gold {
  color:palegoldenrod;
}


</style>


// WEBPACK FOOTER //
// src/components/Navigation-Bar.vue